import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-issueorder-form',
  templateUrl: './issueorder-form.component.html',
  styleUrls: ['./issueorder-form.component.css']
})
export class IssueorderFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/technical/work-order/issue-order/issueorder-form/issueorder-form.component.ts